import { CardElement } from '@stripe/react-stripe-js';
import * as stripeJs from '@stripe/stripe-js';

const CARD_ELEMENT_OPTIONS: stripeJs.StripeCardElementOptions = {
  style: {
    base: {
      'color': '#32325d',
      'fontFamily': '"Helvetica Neue", Helvetica, sans-serif',
      'fontSmoothing': 'antialiased',
      'fontSize': '16px',
      '::placeholder': {
        color: '#aab7c4'
      }
    },
    invalid: {
      color: '#fa755a',
      iconColor: '#fa755a'
    }
  },
  hidePostalCode: true
};

export default function CardSection() {
  return <CardElement options={CARD_ELEMENT_OPTIONS} />;
}